"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = function Loader() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Chatbot__Messenger__Loader-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Chatbot__Messenger__Loader-loader"
  }));
};

var _default = Loader;
exports.default = _default;